// frontend/src/components/common/AlertActionSlot.jsx
//
// The action slot of every alert with an X or buttons: the buttons, then the
// X. MUI renders its own X only when the alert is given no `action`
// (@mui/material Alert.js), so the X is always this one. Where the slot sits
// and how it wraps on a phone is styles/mui-overrides.css (MUI ALERT).

import { Children } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@mui/material';
import { ICON, X } from '../../icons';

export default function AlertActionSlot({ children, onDismiss }) {
  const { t } = useTranslation();
  return (
    <div className="alert-action-slot">
      {Children.toArray(children).length > 0 && <div className="alert-action-buttons">{children}</div>}
      {onDismiss && (
        <span className="alert-dismiss">
          <IconButton size="small" color="inherit" aria-label={t('common.dismiss')} onClick={onDismiss}>
            <X size={ICON.md} />
          </IconButton>
        </span>
      )}
    </div>
  );
}
